<template>
  <div class="footer-bar-white">
    <FooterBarCopyRight />
  </div>
</template>

<style>
.footer-bar-white{
  background-color: #fff;
}
.footer-bar-white p{
  color: #999;
}
</style>

<script>
import FooterBarCopyRight from './FooterBarCopyRight.vue'
export default {
  components: {
    FooterBarCopyRight
  },
}
</script>